import * as React from 'react'
import { ModalWindow } from '$views/components/ModalWindow'
import { Text, Button, Block, Division } from '$views/components'
import { tagManager } from '$infrastructure/tagManager/tagManager'
import { Icon } from '$views/components/Icon'
import { RoundedBlock } from '$views/components/RoundedBlock'
import { oneTimePlanOptions, OneTimePremiumPlan } from '$domain/model/premium/premium.model'

const logoFree = require('$icons/logoFreeFamiliados.svg')
const logoPremium = require('$icons/logoPremiumFamiliados.svg')
const rocketIcon = require('$icons/rocket.svg')

interface Props {
  onClosePopUp: () => void
  onClickMoreInfo: () => void
}

export const SeeMoreCandidatesPremiumPopUp: React.SFC<Props> = ({ onClosePopUp, onClickMoreInfo }) => {
  const onClickButton = () => {
    tagManager.push({ event: 'fam', fam_id: 'PopUpPremiumSeeAllCaregivers' })
    onClickMoreInfo()
  }

  return (
    <ModalWindow onClose={onClosePopUp}>
      <Text title as="span">
        {`Accede a todos los perfiles profesionales desde ${Intl.NumberFormat('es-es').format(
          oneTimePlanOptions.price[OneTimePremiumPlan.oneWeek] / 100,
        )}€`}
      </Text>
      <Text marginTop="base" marginBottom="small">
        O chatea gratis con los 2 profesionales que se apunten primero.
      </Text>
      <RoundedBlock shadow>
        <Block flex justify="between">
          <Icon content={logoPremium} resize={{ width: 150, height: 20 }} marginBottom="mini" />
          <Block textAlign="right">
            <Text menu weight="medium">
              Todos los perfiles
            </Text>
            <Text tiny>Chat sin límites.</Text>
            <Text tiny>
              {`Desde ${Intl.NumberFormat('es-es').format(oneTimePlanOptions.price[OneTimePremiumPlan.oneWeek] / 100)}€.
              Pago único.`}
            </Text>
          </Block>
        </Block>
        <Division marginTop="mini" marginBottom="mini" />
        <Block flex justify="between">
          <Icon content={logoFree} resize={{ width: 120, height: 20 }} marginBottom="mini" />
          <Block textAlign="right">
            <Text menu weight="medium">
              Límite de perfiles
            </Text>
            <Text tiny>Límite de 2 chats.</Text>
            <Text tiny>GRATIS.</Text>
          </Block>
        </Block>
      </RoundedBlock>
      <Block marginTop="medium" marginBottom="medium">
        <Button primary onClick={onClickButton}>
          Acceder a todos los perfiles
        </Button>
        <Block marginTop="mini" flex>
          <Block>
            <Text color="yellow" weight="bold">
              NUEVO!
            </Text>
            <Block flex justify="end">
              <Icon content={rocketIcon} size="ml" marginTop="tiny" marginRight="none" />
            </Block>
          </Block>
          <Division vertical color="yellow" full />
          <Text menu>
            Como usuario Premium también podrás leer los mensajes de presentación que te envíen TODOS los profesionales!
          </Text>
        </Block>
      </Block>
    </ModalWindow>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/PremiumPopUp/SeeMoreCandidatesPremiumPopUp.tsx